import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { firmsApi } from '../api/firms';
import type { ItemType } from 'antd/es/breadcrumb/Breadcrumb';

const routeLabels: Record<string, string> = {
  '/': 'Dashboard',
  '/firms': 'Firmalar',
  '/dealers': 'Bayiler',
  '/users': 'Kullanıcılar',
  '/announcements': 'Duyurular',
  '/agents': 'Agentlar',
  '/agent-versions': 'Agent Versiyonları',
  '/agent-downloads': 'Agent İndirmeleri',
  '/sources': 'Veri Kaynakları',
  '/api-keys': 'API Keys',
  '/logs': 'Loglar',
};

export function Breadcrumbs() {
  const location = useLocation();
  const params = useParams();

  // Check if we're on a firm detail page
  const firmId = params.id && location.pathname.startsWith('/firms/') ? parseInt(params.id) : null;

  const { data: firm } = useQuery({
    queryKey: ['firm', firmId],
    queryFn: () => firmsApi.getById(firmId!),
    enabled: !!firmId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  const buildBreadcrumbItems = (): ItemType[] => {
    const path = location.pathname;
    const items: ItemType[] = [
      {
        key: 'home',
        title: <Link to="/"><HomeOutlined /></Link>,
      },
    ];

    // Dashboard - no additional breadcrumbs
    if (path === '/') {
      return items;
    }

    // Firm detail page
    if (path.startsWith('/firms/') && firmId) {
      items.push({
        key: 'firms',
        title: <Link to="/firms">Firmalar</Link>,
      });
      items.push({
        key: 'firm-detail',
        title: firm?.name || 'Firma Detay',
      });
      return items;
    }

    // Standard pages
    const label = routeLabels[path];
    if (label) {
      items.push({
        key: path,
        title: label,
      });
    }

    return items;
  };

  const items = buildBreadcrumbItems();

  // Don't show breadcrumb if we're just on dashboard
  if (items.length <= 1) {
    return null;
  }

  return (
    <Breadcrumb
      items={items}
      style={{ marginBottom: 16 }}
    />
  );
}
